<template>
  <div class="contactBox">
    <ul class="qqList">
      <li v-for="(item,i) in qqlist" :key="'list'+i">
        <span class="tit" >{{item.name}}：</span>
        <a class="text" :href="'http://wpa.qq.com/msgrd?v=1&uin='+item.qq+'&site=qq&menu=yes'">{{item.qq}}</a>
      </li>
    </ul>
    <ul class="weixinList">
      <li v-for="(item,i) in weixinlist" :key="'list11'+i">
        <span class="tit">{{item.name}}：</span>
        <span class="text">{{item.qq}}</span>
        <div class="imgbox" v-if="item.imgurl">
          <img :src="item.imgurl" alt="">
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';
import { url } from '../assets/js/version';
export default {
  data() {
    return {
      qqlist: [],
      weixinlist: []
    };
  },
  methods: {
    getinfo() {
      axios('/api/About/GetTenantBaseInfoAsync', {
        params: {},
        baseURL: url
      })
        .then((data) => {
          if (data.status === 200) {
            this.qqlist = JSON.parse(data.data.serviceQq).filter((item) => {
              return item.type === 0;
            });
            this.weixinlist = JSON.parse(data.data.serviceQq).filter((item) => {
              return item.type === 1;
            });
          }
        })
        .catch((err) => {
          this.$messageError(err.response.data.message);
        });
    }
  },
  created() {
    this.getinfo();
  }
};
</script>

<style lang="scss" scoped>
.contactBox {
  height: 100%;
  overflow-y: auto;
  .qqList {
    padding: 60px 30px 20px;
    font-size: 16px;
    li {
      margin-bottom: 10px;
      text-align: center;
      .tit {
        display: inline-block;
        vertical-align: middle;
        color: #666;
      }
      .text {
        color: #fff;
        font-size: 13px;
        display: inline-block;
        vertical-align: middle;
        padding: 5px 10px 5px 40px;
        border-radius: 4px;
        background: #2bdd9f url(../assets/images/qq.png) no-repeat 7px center;
        background-size: auto 80%;
      }
    }
  }
  .weixinList {
    padding: 0 30px 20px;
    font-size: 17px;
    li {
      margin-bottom: 20px;
      text-align: center;
      .tit {
        color: #666;
      }
      .text {
        color: red;
      }
      .imgbox {
        text-align: center;
        margin-top: 10px;
        img {
          width: 122px;
          height: 122px;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
